import { render, staticRenderFns } from "./ModalNews.vue?vue&type=template&id=106bdd1a&scoped=true"
import script from "./ModalNews.vue?vue&type=script&lang=js"
export * from "./ModalNews.vue?vue&type=script&lang=js"
import style0 from "./ModalNews.vue?vue&type=style&index=0&id=106bdd1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106bdd1a",
  null
  
)

export default component.exports